<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Session Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="session.title" maxlength="250"></b-input>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column is-6">
                    <b-field label="Start Date & Time" label-position="inside">
                        <b-datetimepicker
                            v-model="session.start_at"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body>
                        </b-datetimepicker>
                    </b-field>
                </div>
                <div class="column is-6">
                    <b-field label="End Date & Time" label-position="inside">
                        <b-datetimepicker
                            v-model="session.end_at"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body>
                        </b-datetimepicker>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Session/Slot" label-position="inside">
                        <b-input v-model="session.slot"></b-input>
                    </b-field>
                </div>
                <div class="column is-6">
                    <b-field label="Presenter" label-position="inside">
                        <b-input v-model="session.presenter"></b-input>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column is-8">
                    <b-field label="Online Presentation/Meeting Link (if applicable)" label-position="inside">
                        <b-input v-model="session.online_mtg_link" placeholder="https:// ..."></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Button Label" label-position="inside">
                        <b-input v-model="session.online_mtg_button"></b-input>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field label="Online Materials Link (if applicable)" label-position="inside">
                        <b-input v-model="session.online_materials_link" placeholder="https:// ..."></b-input>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field label="Session Type" label-position="inside">
                        <b-select v-model="session.type" expanded>
                            <option value="live">Live</option>
                            <option value="ondemand">On-Demand</option>
                            <option value="hybrid">Hybrid</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Registration Enrollment Limit" label-position="inside">
                        <b-input type="number" v-model="session.enroll_limit" min="0"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Certificate PDF" label-position="inside">
                        <b-input v-model="session.certificate_form"></b-input>
                    </b-field>
                </div>
            </div>


        </container-list-item>

        <container-list-item padded no-border>
            <b-field label="Description" message="Description is displayed to participant before they 'plan to attend'.">
                <quill-editor v-model="session.description" ref="descriptionEditor" :options="editorOptions" class="has-background-white content"/>
            </b-field>
        </container-list-item>

        <container-list-item padded no-border>
            <b-field label="Information" message="Information is displayed to participants after they 'plan to attend'.">
                <quill-editor v-model="session.information" ref="informationEditor" :options="editorOptions" class="has-background-white content"/>
            </b-field>
        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'RmcSessionForm',
        props: {
            session: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
